/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qrgenerating1Inputs */

const en_qrgenerating1 = /** @type {(inputs: Qrgenerating1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generating…`)
};

const de_qrgenerating1 = /** @type {(inputs: Qrgenerating1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird erstellt…`)
};

/**
* | output |
* | --- |
* | "Generating…" |
*
* @param {Qrgenerating1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const qrgenerating1 = /** @type {((inputs?: Qrgenerating1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qrgenerating1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_qrgenerating1(inputs)
	return de_qrgenerating1(inputs)
});
export { qrgenerating1 as "qrGenerating" }